import React from "react";
import Marquee from "react-fast-marquee";
import { CLIENT_LOGOS } from "./constants";
import styles from "./index.module.css";

// Scrolling strip of client logos, used on the homepage and the newsroom.
// Each logo renders in its designed Figma box (width x 60px). The box scales
// as a whole through the --logo-scale custom property, so the relative sizing
// between logos is identical at every breakpoint.
export const LogoContainer = () => (
  <Marquee
    gradientColor="transparent"
    speed={40}
    gradient={true}
    gradientWidth={100}
    pauseOnHover={true}
  >
    {CLIENT_LOGOS.map(({ name, src, width }) => (
      <div className={styles.item} key={name}>
        <img
          src={src}
          alt={name}
          loading="lazy"
          className={styles.logo}
          style={{ "--logo-width": `${width}px` }}
        />
      </div>
    ))}
  </Marquee>
);

export default LogoContainer;
